import dayjs from 'dayjs';

/**
 * 날짜 년도.월.일 변환
 * @param date 날짜 문자열 값
 * @example
 *  dateFormat("2023-07-06T05:35:40.197Z") // 2023.07.06
 */
// TODO: dev merge후 정리 필요
export default function dateFormat(
  date: string | null | undefined,
  format = 'YYYY.MM.DD',
): string {
  return date ? dayjs(date).format(format) : '';
}
